import styled from 'styled-components';

export const Anchor = styled.div`
  position: relative;
  width: 0;
  height: 0;
  pointer-events: none;
`;
